import React from 'react';
import { useMarketContext } from '../context/MarketDataContext';
import ShortTickers from '../components/ShortTickers';

export default function ShortAndLong() {
  const { tickers, shortSymbols } = useMarketContext();

  return (
    <div>
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">Short & Long</h1>
      </div>

      <ShortTickers tickers={tickers} shortSymbols={shortSymbols} />
    </div>
  );
}
